import { Phone } from 'lucide-react';

/**
 * Numéro lisible : « 06 25 46 89 12 » (français, par paires) ou « +33 6 25 46 89 12 ».
 * Tout autre format est laissé tel quel. (Même règle que le planning du bureau.)
 */
export function formatPhone(raw?: string | null) {
  const value = (raw ?? '').trim();
  const digits = value.replace(/[\s.\-()]/g, '');
  const pairs = (d: string) => d.replace(/(\d{2})(?=\d)/g, '$1 ');
  if (/^0\d{9}$/.test(digits)) return pairs(digits);
  if (/^(\+33|0033)\d{9}$/.test(digits)) return `+33 ${digits.slice(-9, -8)} ${pairs(digits.slice(-8))}`;
  return value;
}

/** Lien d'appel vers l'élève (le téléphone compose le numéro). */
export default function PhoneLink({
  phone,
  name,
  compact = false,
}: {
  phone?: string | null;
  name: string;
  compact?: boolean;
}) {
  if (!phone) return null;
  const href = `tel:${phone.replace(/[^\d+]/g, '')}`;
  return compact ? (
    <a
      href={href}
      aria-label={`Appeler ${name} au ${formatPhone(phone)}`}
      title={`Appeler ${name}`}
      onClick={(e) => e.stopPropagation()}
      className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-line bg-white text-primary transition-all hover:border-primary-200 hover:shadow-navbar"
    >
      <Phone size={16} aria-hidden />
    </a>
  ) : (
    <a
      href={href}
      aria-label={`Appeler ${name} au ${formatPhone(phone)}`}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex min-h-[28px] items-center gap-1.5 whitespace-nowrap text-[13px] font-medium text-primary-600 hover:underline"
    >
      <Phone size={13} aria-hidden />
      {formatPhone(phone)}
    </a>
  );
}
